<template>
  <section class="admin-content" id="contact-search">
    <Navbar />

    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30" style="margin-top: 35px">
                <div class="card-body">
                  <div class="text-center">
                    <h1><strong>Add Enrollee Form </strong></h1>
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-6" v-if="sector == 'formal'">
                        <div class="form-group">
                          <label for="inputCity">Select Category<span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.sector">
                            <option value="State Civil Servant">
                              State Civil Servant
                            </option>

                            <option value="LGA Civil Servant">
                              LGA Civil Servant
                            </option>

                            <option value="State Public Servant">
                              State Public Servant (Appointees)
                            </option>
                            <option value="State Pensioners Plan">
                              State Pensioners Plan
                            </option>

                            <option value="LGA Pensioners Plan">
                              LGA Pensioners Plan
                            </option>

                            <option value="Organized Private Sector Plan">
                              Organized Private Sector Plan
                            </option>
                            <option value="Tertiary Student Health Insurance Plan (T-SHIP)">
                              Tertiary Student Health Insurance Plan (T-SHIP)
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector == 'State Civil Servant' ||
                          register.sector == 'LGA Civil Servant'
                        ">
                        <label>Select Place of Work </label>
                        <v-select v-model="register.place_of_work" :options="mdas" label="name"></v-select>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <label for="inputEmail4">Institution Name</label>
                        <input type="text" class="form-control" v-model="register.place_of_work"
                          placeholder="example; University of Ife" />
                      </div>
                      <div class="form-group col-md-6" v-if="
                          register.sector == 'Organized Private Sector Plan'
                        ">
                        <label for="inputEmail4">Organization Name</label>
                        <input type="text" class="form-control" v-model="register.place_of_work"
                          placeholder="example;  Name of Company" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN Number</label>
                        <input type="text" required pattern="\d*" maxlength="11" class="form-control"
                          v-model="register.nimc_number" placeholder="NIN Number" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename"
                          placeholder="Middle Name" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Date of Birth: </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.dob" />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <p>
                          <label for="inputPassword4">Date of First Appointment:
                          </label>
                        </p>
                        <input type="date" class="form-control" v-model="register.date_of_entry" />
                      </div>

                      <div class="form-group col-md-12" v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <p>
                          <label for="inputPassword4">Year of Admission:
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.date_of_entry" />
                      </div>

                      <!-- <div
                        class="form-group col-md-4"
                        v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <p><label for="inputPassword4">Expiry Date:  </label></p>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.expiry_date"
                        />
                      </div> -->
                      <div class="form-group col-md-4" v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <p>
                          <label for="inputPassword4">Year of Graduation:
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.expiry_date" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Email</label>
                        <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="text" required pattern="\d*" class="form-control"
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.gender">
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <label for="inputEmail4">Salary Number/Staff ID</label>
                        <input type="text" class="form-control" v-model="register.salary_number"
                          placeholder="Staff ID" />
                      </div>
                      <div class="form-group col-md-6" v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <label for="inputEmail4">Matriculation Number</label>
                        <input type="text" class="form-control" v-model="register.salary_number"
                          placeholder="Matric. Number" required />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <label for="inputEmail4">Grade Level/Step</label>
                        <input type="text" class="form-control" v-model="register.grade_level"
                          placeholder="Grade Level/Step" />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        ">
                        <label for="inputEmail4">Class Year</label>
                        <input type="text" class="form-control" v-model="register.grade_level" placeholder="200L" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">LGA <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward </label>
                        <select class="form-control" v-model="register.ward" @change="getProvidersByWards($event)">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Principal Facility for Accessing Health Care
                        </label>
                        <v-select v-model="register.provider_id" :options="providers" label="agency_name"></v-select>
                      </div>

                      <!-- <div class="form-group col-md-6">
                        <label
                          >Alternate Facility for Accessing Health Care
                        </label>
                        <v-select
                          v-model="register.alternate_provider_id"
                          :options="providers"
                          label="agency_name"
                        ></v-select>
                      </div> -->

                      <!-- <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div> -->

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address</label>
                        <input type="text" class="form-control" v-model="register.address" placeholder="1234 Main St" />
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="d-block mb-1">Enrollee Photo <span class="text-danger">*</span></label>
                      <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                        Capture Photo <i class="fe fe-camera"></i>
                      </button>
                      <div class="mt-2" v-if="register.user_image">
                        <img
                          :src="register.user_image"
                          class="rounded"
                          style="width:120px;height:120px;object-fit:cover;"
                          alt="Enrollee Photo"
                          onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
                        />
                        <div class="mt-2" v-if="register.user_image && photoOriginal">
                          <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                            <i class="fe fe-crop mr-1"></i> Adjust
                          </button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong>
                      </p>

                      <ul class="declaration-list">
                        <li>
                          I/We hereby declare, on my behalf and on behalf of
                          all persons proposed to be insured that the above
                          statements, answers and/or particulars given by me
                          are true and complete in all respects to the best of
                          my knowledge and that I/We am/ are authorized to
                          propose on behalf of these other persons.
                        </li>
                        <li>
                          I understand that the information provided by me
                          will form the basis of insurance policy, is subject
                          to the Board approved underwriting policy of KGSHIA
                          and that the policy will come into force only after
                          full receipt of the premium chargeable.
                        </li>
                        <li>
                          I/ We further declare that I/We will notify in
                          writing any change occurring in the occupation or
                          general health of the life to be insured/ proposer
                          after the proposal has been submitted but before
                          communication of the risk acceptance by KGSHIA.
                        </li>
                        <li>
                          I/We declare and consent to KGSHIA seeking medical
                          information from any hospital who at any time has
                          attended on the life to be insured/ proposer or from
                          any past or present employer concerning anything
                          which affects the physical and mental health of the
                          life to be assured/proposer and seeking information
                          from any insurance company to which an application
                          for insurance on the life to be assured/ proposer
                          has been made for the purpose of underwriting the
                          proposal and/or claim settlement.
                        </li>
                        <li>
                          I/ We authorize KGSHIA to share information
                          pertaining to my proposal including the medical
                          records for the sole purpose of proposal
                          underwriting and/or claims settlement and with any
                          Governmental and/or Regulatory Authority.
                        </li>
                      </ul>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="declarationAccept"
                            v-model="declarationAccepted"
                          />
                          <label class="form-check-label" for="declarationAccept">
                            I/We have read, understood and accept all of the
                            declarations above
                            <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-success btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
            <PhotoCropper ref="photoCropper" />
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";

  export default {
    components: { PhotoCropper,
      Navbar,
      Loading,
    },
    data() {
      return {
        photoOriginal: "",
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        clients: "",
        providers: "",
        sector: "formal",
        mdas: "",
        wards: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        lga_states: "",
        response: "",
        declarationAccepted: false,
        register: {
          type: "client",
          sector: "formal",
          plan_type: "Family",
          user_image: "",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          email: "",
          phone_number: "",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          weight: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: "",
          salary_number: "",
          provider_id: "",
          alternate_provider_id: "",
          finger_print: "",
          place_of_work: "",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      //
    },

    methods: {
      submitForm() {
        if (!this.register.user_image) {
          this.$toasted.error(`Enrollee photo is required`, {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        if (!this.declarationAccepted) {
          this.$toasted.error(`You must accept the declaration to continue`, {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        this.registerUserEmployee();
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2669`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/90`, {
            params: {
              type: "public",
            },
          })
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            agency_id: 90,
            user_image: this.register.user_image,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            plan_type: this.register.plan_type,
            type: this.register.type,
            sectorType: this.sector,
            provider_id: this.register.provider_id.id,
            alternate_provider_id: this.register.alternate_provider_id.id,
            state: "2669",
            role: 0,
            password: "euhler",
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            address1: this.register.address,
            genotype: this.register.genotype,
            dob: this.register.dob,
            // expiry_date: this.register.expiry_date,
            date_of_entry: this.register.date_of_entry,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work.name,
            point_of_care: this.register.provider_id.id,
            // finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            marital_status: this.register.marital_status,
            // category_of_vulnerable_group: this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.getClients();
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.response = error.response.data.errors;
            this.$toasted.error(`${JSON.stringify(this.response)}`, {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/90`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/90/${this.register.localgovt}/${this.register.ward}`
          )
          .then((response) => {
            this.providers_wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.register.user_image = cropped;
        return true;
      },
      removePhoto() {
        this.register.user_image = "";
        this.photoOriginal = "";
      },

      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 70,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Camera,
          });
          if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
          this.$toasted.info("Photo captured successfully!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera.", {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
    },
    created() {
      this.fetchLga();
      this.getMDAs();
      this.getProviders();
    },
  };
</script>

<style scoped>
.declaration-list { padding-left: 1.2rem; font-size: 0.9rem; color: #475569; }
.declaration-list li { margin-bottom: 8px; }
</style>